import { Component, OnInit } from '@angular/core';
import { Utility } from '../../shared/utility/utility';
import { BannerService } from '../../services/banner.service';

@Component({
  selector: 'app-homepage-promotions',
  templateUrl: './homepage-promotions.component.html',
  styleUrls: ['./homepage-promotions.component.scss']
})

export class HomepagePromotionsComponent implements OnInit {
  banners = null;
  constructor(private utils: Utility, private bannerService:BannerService) { }

  ngOnInit() {
    this.loadbanner();
  }

  loadbanner() {
    let bannerZoneID = 17;
    let bannerRequest = { 'zoneId': bannerZoneID };
    if (this.utils.getAffliateId('affiliate')) {
      bannerRequest["affiliateId"] = this.utils.getAffliateId('affiliate')
    } 
    Promise.resolve(this.bannerService.getBanners(bannerRequest)).then(banners => {
      if (banners && banners.length > 0) {
        this.banners = banners[0];
      }
    });
  }
}
